// Collection pagination
class pagination extends HTMLElement {
    constructor() {
        super();
        this.loadMoreButton = this.querySelector('.load-more.button, .load-more.button.load-ajax');
        if (this.isElementAvailable(this.loadMoreButton)) {
            this.loadMoreButton.addEventListener('click', this.onloadMoreButtonClick.bind(this));
        }

        this.pathName = window.location.href.replace(/\W+/g, '-').replace(/\-$/, '').toLowerCase();

        history.scrollRestoration = "manual";
        this.moveToLastScrolledPosition();

        window.addEventListener("unload", this.setLastScrolledPosition.bind(this));
        window.addEventListener("pagehide", this.setLastScrolledPosition.bind(this));

        this.currentCount = document.querySelector('.current_count');
        if (this.isElementAvailable(this.currentCount)) {
            this.currentCount.innerHTML = document.querySelector("#product-grid").getElementsByTagName("li").length - 1;
        }

        this.calculateProgressBar();
    }

    calculateProgressBar() {
        const currentShowCount = document.querySelector("#product-grid").getElementsByTagName("li").length - 1;
        const totalCount = document.getElementById('ProductCountDesktop').getAttribute('collection_total_product');
        
        document.querySelector(".skillBarValue").style.width = (currentShowCount / totalCount)*100+'%';
    }

    isElementAvailable(element) {
        return typeof(element) !== 'undefined' && element !== null
    }

    setLastOpenedPagination() {
        sessionStorage.setItem("lastOpenedPagination_" + this.pathName, this.loadMoreButton.dataset.currentPage.toString());
    }

    setLastScrolledPosition() {
        sessionStorage.setItem("lastScrolledPosition_" + this.pathName, document.documentElement.scrollTop.toString());
    };

    moveToLastScrolledPosition() {
        const lastScrolledPosition = sessionStorage.getItem("lastScrolledPosition_" + this.pathName) || '0';
        const lastOpenedPagination = sessionStorage.getItem("lastOpenedPagination_" + this.pathName) || '1';
        if (parseInt(lastOpenedPagination) > 1) {
            let nextUrl = this.loadMoreButton.getAttribute('next-page-url');
            const sourceMainItemWrapDiv = document.querySelector('#product-grid');
            const sourceLoadMoreButton = this.loadMoreButton;
            const nextUrls = [];
            
            for (let page = 2; page <= lastOpenedPagination; page++) {
                const regex = /page=\d/gm;
                const replacement = `page=${page}`;
                const replacedNextUrl = nextUrl.replace(regex, replacement);
                nextUrls.push(replacedNextUrl);
            }

            Promise.all(nextUrls.map(url =>
                fetch(url, { method: 'GET' })
                .then((response) => response.text())
                ))
                .then(responses => {
                    responses.forEach(html => {
                        var parser = new DOMParser();
                        var doc = parser.parseFromString(html, 'text/html');
                        
                        // Find the div you want to remove
                        const divToRemove = doc.querySelector('.grid__item.text-image-grid-item');
                        if (divToRemove) {
                            divToRemove.remove();
                        }
                        
                        const nextPageContent = doc.querySelector('.product-grid').innerHTML;
                        
                        const dataCurrentPage = doc.querySelector('.load-more.button').getAttribute('data-current-page');
                        const nextPageurlCheck = doc.querySelector('.load-more.button').getAttribute('next-page-url');
                        
                        sourceMainItemWrapDiv.innerHTML += nextPageContent;
                        
                        sourceLoadMoreButton.setAttribute('next-page-url', nextPageurlCheck);
                        sourceLoadMoreButton.setAttribute('data-current-page', dataCurrentPage);
                        
                        if (nextPageurlCheck === 'empty') {
                            this.classList.add('hide');
                        }
                        this.currentCount.innerHTML = document.querySelector("#product-grid").getElementsByTagName("li").length - 1;
                        
                    });
                    this.refreshReview();
                    this.refreshBackInStock();
                    this.calculateProgressBar();
                    this.setLastOpenedPagination();
                    if (parseInt(lastScrolledPosition) > 0) {
                        window.scrollTo({
                            top: lastScrolledPosition,
                            behavior: "instant"
                        });
                    }
                })
                .catch(errorMsg => { console.log(errorMsg); });
        } else {
            if (parseInt(lastScrolledPosition) > 0) {
                window.scrollTo({
                    top: lastScrolledPosition,
                    behavior: "instant"
                });
            }
        }
    }

    onloadMoreButtonClick(evt) {
        evt.preventDefault();
        this.renderProducts();
    }
    
    refreshReview() {
        if(typeof yotpo !== 'undefined' && typeof yotpo.refreshWidgets === 'function') {
            yotpo.refreshWidgets();
        }
    }
    
    refreshBackInStock() {
        setTimeout(() => {
            var productContainers = document.querySelectorAll('.klaviyo-product-container');
            productContainers.forEach(container => {
                var productId = container.getAttribute('data-klaviyo-handle');
                var buttonContainer = container.querySelector('.klaviyo-button-container');
                
                buttonContainer.innerHTML = '';
                
                var klaviyoButton = document.createElement('a');
                klaviyoButton.className = 'btn back_in_stock_product  quick-add__submit button button--full-width button--secondary klaviyo-bis-trigger';
                klaviyoButton.style.textAlign = 'center';
                klaviyoButton.style.margin = '0px';
                klaviyoButton.innerText = 'Notify Me When Available';
                klaviyoButton.setAttribute('data-klaviyo-handle', productId);
                
                buttonContainer.appendChild(klaviyoButton);
                
                klaviyo.enable("backinstock", {
                    trigger: {
                        product_page_text: "Notify Me When Available",
                        product_page_class: "klaviyo-bis-trigger btn button",
                        product_page_text_align: "center",
                        product_page_margin: "0px",
                        replace_anchor: false,
                        collection_page_class: 'btn back_in_stock_product  quick-add__submit button button--full-width button--secondary',
                        collection_page_text_align: 'center',
                        collection_page_text: 'Notify Me When Available',
                        collection_page_padding: 'inherit'
                    },
                    modal: {
                        headline: "{product_name}",
                        body_content: "Register to receive a notification when this item comes back in stock.",
                        email_field_label: "Email",
                        button_label: "Notify me when available",
                        subscription_success_label: "You're in! We'll let you know when it's back.",
                        footer_content: '',
                        additional_styles: `@import url('https://fonts.googleapis.com/css2?family=Alata&display=swap');.btn-success{width: 100%;min-height: 48px;border-radius:0px;background: #232936;color: white;display: flex;align-items: center;justify-content: center;text-decoration: none;font-size: 14px;line-height: 14px;letter-spacing: 1px;text-transform: uppercase;color: #FFFFFF;};#klaviyo-bis-modal p{font-size:15px;line-height:140%;letter-spacing:.2px;margin:16px 0}#klaviyo-bis-modal .input-lg{font-size:15px;letter-spacing:.2px;border:none;box-shadow:none;border-bottom:1px solid #232936;border-radius:0;padding-left:12px}.small-print{margin:0}#klaviyo-bis-modal .form-group{margin-bottom:0}.form-group{margin-bottom:15px}#klaviyo-bis-modal{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)} #klaviyo-bis-modal #container{margin-top:0;padding: 32px;border-radius: 0px;}  #klaviyo-bis-modal button.close.klaviyo-bis-close{top:30px;right:30px;background-image:url("data:image/svg+xml,%3Csvg width='31' height='30' viewBox='0 0 31 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M23 7.5L8 22.5' stroke='%23232936' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M8 7.5L23 22.5' stroke='%23232936' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");width:30px;height:30px;text-indent:-9999px} .modal-title{font-weight:400;font-size:28px;line-height:120%} #klaviyo-bis-modal #container p{font-size:15px;line-height:140%} @media screen and (max-width:990px){#klaviyo-bis-modal{max-width:100%;width:100%;bottom:0;transform:none;left:0;top:inherit}#klaviyo-bis-modal #container{padding:20px}#klaviyo-bis-modal button.close.klaviyo-bis-close{top:20px;right:15px}.modal-title{font-size:24px}};} `,
                        drop_background_color: "#000",
                        background_color: "#ffffff",
                        text_color: "#232936",
                        button_text_color: "white",
                        button_background_color: "#232936",
                        close_button_color: "#232936",
                        error_background_color: "#fcd6d7",
                        error_text_color: "#C72E2F",
                        success_background_color: "#d3efcd",
                        success_text_color: "#1B9500"
                    }
                }, productId, buttonContainer);
            });
        }, 1000);
    }

    renderProducts() {
        var url = this.loadMoreButton.getAttribute('next-page-url');
        var totalPage = document.querySelector('.load-more.button').getAttribute('total-page');
        var sourceMainItemWrapDiv = document.querySelector('#product-grid');
        var sourceLoadMoreButton = this.loadMoreButton;

        // Making our request
        fetch(url, { method: 'GET' })
          .then((response) => response.text())
          .then(html => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            // Find the div you want to remove
            const divToRemove = doc.querySelector('.grid__item.text-image-grid-item');
            if (divToRemove) {
              divToRemove.remove();
            }
            const nextPageContent = doc.querySelector('.product-grid').innerHTML;

            var dataCurrentPage = doc.querySelector('.load-more.button').getAttribute('data-current-page');
            var nextPageurlCheck = doc.querySelector('.load-more.button').getAttribute('next-page-url');

            sourceMainItemWrapDiv.innerHTML += nextPageContent;

            sourceLoadMoreButton.setAttribute('next-page-url', nextPageurlCheck);
            sourceLoadMoreButton.setAttribute('data-current-page', dataCurrentPage);
            (function e(){var e=document.createElement("script");e.type="text/javascript",e.async=true,e.src="//staticw2.yotpo.com/UvEGuUcwhYjpOn2CinYsqChDXFz177IXV5vKclvM/widget.js";var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t)})();

            this.refreshReview();
            this.refreshBackInStock();

            if (nextPageurlCheck == 'empty') {
              this.classList.add('hide');
            }
            this.calculateProgressBar();
            this.currentCount.innerHTML = document.querySelector("#product-grid").getElementsByTagName("li").length - 1;
            this.setLastOpenedPagination();
          })
          .catch(errorMsg => { console.log(errorMsg); });
      }


}

customElements.define('paginate-section', pagination);
